/**
 * Generates sequential tab indices starting at the provided offset.
 * Keeps internal mutable counter via closure so that DynamicForm
 * can obtain the next index on every render pass without relying on
 * React state (which could trigger unwanted re-renders).
 *
 * @param start - Starting tab index value (defaults to 1)
 * @returns Function that returns the next sequential tab index
 *
 * @example
 * ```tsx
 * const nextTabIndex = createTabIndexGenerator(1)
 * const firstIndex = nextTabIndex() // returns 1
 * const secondIndex = nextTabIndex() // returns 2
 * ```
 */
export const createTabIndexGenerator = (start = 1) => {
  let current = start
  return () => current++
}
